import { collection } from 'firebase/firestore';
import { db } from './config';

const responseRef = collection(db, 'response');
export default responseRef;
